import DropDownListModel from "./dropdownlistmodel"

export default class RadioButtonModel {
    constructor(
        labelText: string,
        radioValue: string,
        /** Voidaan käyttää esim rightslotTemplaten tallentamiseen jos useammalla radiobuttonilla on sama rightslot */
        groupName?: string,
        dropDownListItems?: DropDownListModel[] | null,
        selectedDropDownListValue?: string) {
            this.labelText = labelText
            this.radioValue = radioValue
            this.groupName = groupName
            this.dropDownListItems = dropDownListItems
            this.selectedDropDownListValue = selectedDropDownListValue
        }

    labelText!: string
    radioValue!: string
    groupName?: string = ""
    dropDownListItems?: DropDownListModel[] | null
    selectedDropDownListValue?: string

    static createEmpty(): RadioButtonModel {
        return new RadioButtonModel("", "", "", null, "0")
    }
}
